import { create } from 'zustand';
import { supabase } from '@/lib/supabase';

interface WorksState {
  totalWorksCount: number;
  setTotalWorksCount: (count: number) => void;
}

export const useWorksStore = create<WorksState>((set) => ({
  totalWorksCount: 0,
  setTotalWorksCount: (count) => set({ totalWorksCount: count }),
}));